import { useEffect, useState } from 'react';
import { Box, Typography, Button, useTheme } from '@mui/material';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import { useHistory } from 'react-router';

import Navigate from '@shared/components/Navigate/navigate';
import useWindowSize from '@shared/hooks/useWindowsSize';
import { getLotteryByLastSite } from '@shared/services/services';

import Formulary from './Formulary';
import { sxForm } from './Formulary/styles';
import { LOTTERY_LAYOUT, showGitRegistrationForSite } from './siteLayouts';

const LotteryPage = () => {
  const {
    breadcrumbLast,
    breadcrumbMb,
    contentPt,
    contentPb,
    legalInsideCard,
    cardWidth,
  } = LOTTERY_LAYOUT;
  const showGitRegistration = showGitRegistrationForSite(
    process.env.REACT_APP_SITE
  );

  const screenSize = useWindowSize();
  const theme = useTheme();
  const sx = sxForm(theme);
  const history = useHistory();

  const [sorteo, setSorteo] = useState([]);
  const [statusModal, setStatusModal] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [isGitRegistered, setIsGitRegistered] = useState('yes');

  const successText = sorteo.confirmation_message;
  const failText = sorteo.rejection_message;

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchGetLottery();
  }, []);

  const fetchGetLottery = async () => {
    try {
      const result = await getLotteryByLastSite();
      setSorteo(result);
    } catch (error) {
      console.error('error', error);
    }
  };

  const imageSrc =
    screenSize.width > 600 ? sorteo.url_image : sorteo.url_image_mobile;

  const handleButton = () => {
    setShowModal(false);
    history.push('/');
  };

  const dialogTitle =
    showGitRegistration && isGitRegistered === 'no'
      ? '¡Regístrate para participar!'
      : '¡Ya estás participando!';

  return (
    <Box sx={{ overflow: 'hidden', width: '100%' }}>
      <Box
        component="img"
        src={imageSrc}
        alt="Sorteo"
        sx={{
          width: '100%',
          height: { xs: 200, sm: 300, md: 400 },
          objectFit: 'cover',
          display: 'block',
        }}
      />

      <Box
        sx={{
          backgroundColor: '#F2F2F2',
          pt: contentPt,
          pb: contentPb,
          px: { xs: 2, sm: 4 },
        }}
      >
        {sorteo?.is_active && (
          <Box sx={{ mb: breadcrumbMb }}>
            <Navigate
              steps={[
                { title: 'Inicio', navigate: '/flights', data: null },
                { title: breadcrumbLast, navigate: null, data: null },
              ]}
            />
          </Box>
        )}

        <Formulary
          sorteo={sorteo}
          setStatusModalProp={setStatusModal}
          setShowModalProp={setShowModal}
          showGitRegistration={showGitRegistration}
          isGitRegistered={isGitRegistered}
          setIsGitRegistered={setIsGitRegistered}
          cardWidth={cardWidth}
          legalInsideCard={legalInsideCard}
        />

        <Dialog
          aria-labelledby="simple-dialog-title"
          open={showModal}
          PaperProps={{ sx: { borderRadius: 2, p: 5 } }}
          id="DIALOG"
        >
          <DialogTitle
            id="simple-dialog-title"
            sx={{ display: 'flex', justifyContent: 'center' }}
          >
            <Typography
              sx={{
                fontSize: 24,
                fontWeight: 800,
                color: statusModal ? '#64bb9e' : '#ba6565',
              }}
            >
              {dialogTitle}
            </Typography>
          </DialogTitle>

          <Box sx={{ my: 2 }}>
            <Typography>{statusModal ? successText : failText}</Typography>
          </Box>

          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
            <Button
              variant="contained"
              sx={{
                ...sx.sendButton,
                fontSize: 18,
                fontWeight: 800,
              }}
              onClick={handleButton}
            >
              Volver a la web
            </Button>
          </Box>
        </Dialog>
      </Box>
    </Box>
  );
};

export default LotteryPage;
